module.exports = __webpack_public_path__ + "media/luxury-2026/glass-ceiling-entry-ebde326d.jpg";